export default __webpack_public_path__ + "static/media/nine.c8217946.jpg";